// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"70edc199","147":"e9361059","348":"c784dfa6","737":"d9feb704","940":"3b7a12f1"}[chunkId] + ".chunk.js";
};